import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@systemeio/ui';
import React, { Dispatch, SetStateAction } from 'react';
import { FormSelectInlineBordered } from 'shared/components/form-select/form-select-inline-bordered';
import TransLoco from 'shared/components/trans-loco';
import { TLocoType, useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { DateRangeEnum } from '../enums/date_range_enum';
import { ActionRemovalConditionsEnum, RemovalConditionsInterface } from '../types/removal-conditions-interface';
const getActionRemovalConditionsData = (t: TLocoType) => [{
  id: ActionRemovalConditionsEnum.delete,
  caption: t('global.delete').toLowerCase()
}, {
  id: ActionRemovalConditionsEnum.unsubscribe,
  caption: t('dashboard.settings.mailing.action_removal_conditions_unsubscribe').toLowerCase()
}];
const getDateRangeData = Object.values(DateRangeEnum).map((id, index) => ({
  id,
  caption: `${index + 1}`
}));
interface ContactsCleaningSettingsProps {
  removalConditions: RemovalConditionsInterface;
  setTempStateRemovalConditions: Dispatch<SetStateAction<RemovalConditionsInterface[]>>;
}
export const ContactsCleaningSettings = t0 => {
  const $ = _c(52);
  const {
    removalConditions,
    setTempStateRemovalConditions
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== removalConditions || $[1] !== setTempStateRemovalConditions) {
    t1 = () => setTempStateRemovalConditions(prevState => prevState.map(item => {
      if (item.type === removalConditions.type) {
        return {
          ...removalConditions,
          active: !removalConditions.active
        };
      }
      return item;
    }));
    $[0] = removalConditions;
    $[1] = setTempStateRemovalConditions;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== removalConditions.active || $[4] !== t1) {
    t2 = <Checkbox value={removalConditions.active} className="pt-1" onChange={t1} />;
    $[3] = removalConditions.active;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.settings.mailing.contacts_cleaning_checkbox_label");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span>{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = getActionRemovalConditionsData(t);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== removalConditions || $[13] !== setTempStateRemovalConditions) {
    t6 = value => value && setTempStateRemovalConditions(prevState_0 => prevState_0.map(item_0 => {
      if (item_0.type === removalConditions.type) {
        return {
          ...removalConditions,
          action: value
        };
      }
      return item_0;
    }));
    $[12] = removalConditions;
    $[13] = setTempStateRemovalConditions;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== removalConditions.action || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className="mx-1 inline-block"><FormSelectInlineBordered data={t5} value={removalConditions.action} onChange={t6} className="px-1 py-0.5 pr-4" arrowButtonClassName="right-1 h-[26px] w-[10px]" withoutCloseIcon={true} /></div>;
    $[15] = removalConditions.action;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      b: <b />
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = <span><TransLoco t={t} i18nKey="dashboard.settings.mailing.contacts_cleaning_text" components={t8} /></span>;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== removalConditions || $[23] !== setTempStateRemovalConditions) {
    t10 = value_0 => value_0 && setTempStateRemovalConditions(prevState_1 => prevState_1.map(item_1 => {
      if (item_1.type === removalConditions.type) {
        return {
          ...removalConditions,
          dateRange: value_0
        };
      }
      return item_1;
    }));
    $[22] = removalConditions;
    $[23] = setTempStateRemovalConditions;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== removalConditions.dateRange || $[26] !== t10) {
    t11 = <div className="mx-1 inline-block"><FormSelectInlineBordered data={getDateRangeData} value={removalConditions.dateRange} onChange={t10} withoutCloseIcon={true} className="px-1 py-0.5 pr-4" arrowButtonClassName="right-1 h-[26px] w-[10px]" /></div>;
    $[25] = removalConditions.dateRange;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = removalConditions.type === "email" ? "dashboard.settings.mailing.contacts_cleaning_never_already" : "dashboard.settings.mailing.contacts_cleaning_never_purchased";
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      b: <b />
    };
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t || $[30] !== t12) {
    t14 = <span><TransLoco t={t} i18nKey={t12} components={t13} /></span>;
    $[29] = t;
    $[30] = t12;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14 || $[34] !== t4 || $[35] !== t7 || $[36] !== t9) {
    t15 = <div>{t4}{t7}{t9}{t11}{t14}</div>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t4;
    $[35] = t7;
    $[36] = t9;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== removalConditions.action || $[39] !== removalConditions.lastCount || $[40] !== removalConditions.lastExecutionDate || $[41] !== t || $[42] !== user?.dateFormat || $[43] !== user?.timeFormat || $[44] !== user?.timezone) {
    t16 = <div>({removalConditions.lastCount !== 0 && removalConditions.lastExecutionDate ? <TransLoco t={t} i18nKey="dashboard.settings.mailing.contacts_cleaning_action_performed" components={{
        b: <b />
      }} values={{
        count: removalConditions.lastCount,
        action: removalConditions.action === ActionRemovalConditionsEnum.delete ? t("dashboard.settings.mailing.contacts_cleaning_action_deleted") : t("dashboard.settings.mailing.contacts_cleaning_action_unsubscribed"),
        date: dateTimeFormat(removalConditions.lastExecutionDate, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })
      }} /> : <TransLoco t={t} i18nKey="dashboard.settings.mailing.contacts_cleaning_action_no_performed" components={{
        b: <b />
      }} />})</div>;
    $[38] = removalConditions.action;
    $[39] = removalConditions.lastCount;
    $[40] = removalConditions.lastExecutionDate;
    $[41] = t;
    $[42] = user?.dateFormat;
    $[43] = user?.timeFormat;
    $[44] = user?.timezone;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t15 || $[47] !== t16) {
    t17 = <div>{t15}{t16}</div>;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t17 || $[50] !== t2) {
    t18 = <div className="flex items-start gap-2">{t2}{t17}</div>;
    $[49] = t17;
    $[50] = t2;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  return t18;
};